module.exports = __webpack_public_path__ + "static/media/Rhyperior_gaussian2.58f4a591.png";